import React from 'react';
import { Check } from 'lucide-react';

/**
 * 1. CONFIGURATION DATA
 * Easily update the checklist or the process steps here.
 */
const CHECKLIST_ITEMS = [
    "Private Limited / LLP / OPC registration",
    "GST registration & monthly filing",
    "Income tax return filing",
    "ROC compliance & annual filing"
];

const STEPS = [
    {
        number: "01",
        title: "Choose business structure",
        description: "Select Private Limited, LLP, or OPC based on your needs."
    },
    {
        number: "02",
        title: "We prepare & register",
        description: "DIN, DSC, company name approval, incorporation documents."
    },
    {
        number: "03",
        title: "GST & Tax setup",
        description: "GST registration, PAN, TAN, and bank account opening support."
    },
    {
        number: "04",
        title: "Stay compliant",
        description: "GST filing, income tax returns, ROC compliance & annual filing."
    }
];

const BusinessStartup = () => {
    return (
        <section className="bg-white py-24 px-6">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-start">

                {/* Left Column: Heading and Checklist */}
                <div className="w-full lg:w-1/2 space-y-8">
                    <div className="space-y-6">
                        <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B3C] leading-tight">
                            Start your business in India
                        </h2>
                        <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
                            Choose your business structure - Private Limited, LLP, or OPC. We guide
                            you through company registration, GST registration, tax filing, and all
                            compliance requirements so you can focus on growing your business.
                        </p>
                    </div>

                    <ul className="space-y-4">
                        {CHECKLIST_ITEMS.map((item, index) => (
                            <li key={index} className="flex items-center gap-3">
                                <Check size={20} className="text-green-600 stroke-[3px]" />
                                <span className="text-gray-700 font-medium">{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Right Column: Numbered Process Cards */}
                <div className="w-full lg:w-1/2 space-y-4">
                    {STEPS.map((step, index) => (
                        <div
                            key={index}
                            className="group border border-gray-100 rounded-2xl p-6 hover:border-blue-100 hover:bg-blue-50/30 transition-all duration-300"
                        >
                            <div className="flex gap-6">
                                <span className="text-sm font-bold text-gray-400 mt-1">
                                    {step.number}
                                </span>
                                <div className="space-y-1">
                                    <h3 className="text-xl font-bold text-[#1A2B3C] group-hover:text-blue-700 transition-colors">
                                        {step.title}
                                    </h3>
                                    <p className="text-gray-500 text-sm leading-relaxed">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default BusinessStartup;